class ShowMoreItems {
    hiddenItems

    constructor(el) {
        this.el = el;
        this.itemsPerStep = this.el.dataset.step;
        this.items = this.el.querySelectorAll(".js-list li");
        this.btn = this.el.querySelector(".js-show-more-btn");
        this.counter = this.btn.querySelector(".js-counter");
        
        this.onMounted();
    }

    onMounted() {
        if (this.items.length > this.itemsPerStep) {
            if (this.el.closest(".link-block")) {
                this.hiddenItems = [...this.items].slice(this.itemsPerStep - 1);
            } else {
                this.hiddenItems = [...this.items].slice(this.itemsPerStep);
            }
            this.hiddenItems.forEach(link => link.classList.add("hidden"));

            this.counter.textContent =
            this.hiddenItems.length > this.itemsPerStep
                ? this.itemsPerStep
                : this.hiddenItems.length;
        } else {
            this.btn.classList.add("hidden");
        }

        this.btn.addEventListener("click", (e) => {
            e.preventDefault();
            this.showMoreBtnClickHandler();
        });
    }

    showMoreBtnClickHandler = () => {
        [...this.items]
            .filter(item => item.classList.contains("hidden"))
            .slice(0, this.itemsPerStep)
            .forEach(item => (item.classList.remove("hidden")));

        const itemsCount = [...this.items].filter(item => item.classList.contains("hidden")).length;

        if (itemsCount < 1) {
            this.btn.remove();
        } else {
            this.counter.textContent = itemsCount;
        }
    };
}

window.addEventListener("load", function() {
    document
        .querySelectorAll(".js-show-more-items")
        .forEach(item => new ShowMoreItems(item));
});
